import React from 'react';
import { Container } from '@adobe/aem-react-editable-components';
export function ExperienceFragment(props) {
    const { configured } = props;
    if (!configured) {
        return null;
    }
    return React.createElement(Container, { ...props });
}
ExperienceFragment.displayName = 'ExperienceFragment_Component';
